// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import BaseButton from '@/components/base/base-button.vue';
import BaseCheckbox from '@/components/base/base-checkbox.vue';
import BaseImage from '@/components/base/base-image.vue';
import BaseInput from '@/components/base/base-input.vue';
import BaseProgressBar from '@/components/base/base-progress-bar.vue';
import BaseSelect from '@/components/base/base-select.vue';
import BaseTabs from '@/components/base/base-tabs.vue';
import BaseTextButton from '@/components/base/base-text-button.vue';
import AppHeader from '@/components/shared/app-header.vue';
import AppLoader from '@/components/shared/app-loader.vue';
import type { App, Component } from 'vue';

export default {
  install: (app: App<Element>) => {
    // Define a properly typed object for components
    const components: Record<string, Component> = {
      BaseButton: BaseButton,
      BaseCheckbox: BaseCheckbox,
      BaseImage: BaseImage,
      BaseInput: BaseInput,
      BaseProgressBar: BaseProgressBar,
      BaseSelect: BaseSelect,
      BaseTabs: BaseTabs,
      BaseTextButton: BaseTextButton,
      AppHeader: AppHeader,
      AppLoader: AppLoader,
    };

    // Register each component globally
    Object.keys(components).forEach(cmpName => {
      const component = components[cmpName];
      app.component(cmpName, component);
    });
  },
};
